<template>
  <div class="activity"> 
      <div class="text-box">
        <div class="part">
          <p>打开书本见识世界</p>
          <p>合上书本认识自己</p>
          <p>读书是与自己、与世界、与万物的对话</p>
        </div>
        <div class="part">
          <p>每一本书都是一把钥匙</p>
          <p>为你打开世界的一道道门</p>
        </div>
        <div class="part">
          <p>这个“世界读书日”</p>
          <p>让我们读世界，见自我</p>
        </div>
        <div class="part">
          <p>浙江省高校图书馆邀您参与</p>
          <p>“中文在线杯”书声琅琅听书问答</p>
          <p>有奖知识竞赛活动</p>
        </div>
        <div class="part">
          <p>共同感受知识的魅力</p>
          <p>让你我成为终身学习的同行者</p>
        </div>
     </div>
     <!-- 简介 --> 
      <img src="../../assets/img/pc/activity/activity_title.png" class="title-img"> 
      <div class="code-box">
        <div class="code">
          <div>
            <img class="code-img" src="../../assets/img/m/activity/code.jpg" alt />
            <p>微信扫一扫参与活动</p>
          </div>
          </div> 
    </div>
      <div class="prize-dec">
        <div class="prize-img">
          <div class="item">
            <img src="../../assets/img/m/activity/prize1.png" alt />
            <p class="level"><span>一等奖</span><span>3名</span></p>
            <p class="name">荣誉证书+中文在线电纸书阅读器</p>
          </div>
          <div class="item">
            <img src="../../assets/img/m/activity/prize2.png" alt />
            <p class="level"><span>二等奖</span><span>8名</span></p>
            <p class="name">荣誉证书+山地自行车</p>
          </div>
          <div class="item">
            <img src="../../assets/img/m/activity/prize3.png" alt />
            <p class="level"><span>三等奖</span><span>50名</span></p>
            <p class="name">荣誉证书+蓝牙音箱</p>
          </div>
        </div>
        <!-- <p class="remark"> （礼品以实物为准）</p> -->
        <div class="other">
          <p>优秀奖：荣誉证书+国风U盘（100名）</p>
          <p>优秀组织奖：荣誉奖牌+中文在线书香中国数据库1年使用权限</p> 
        </div>
        <div class="activity-box">
          <div class="item"> 
            <p class="title">活动时间</p>
             <p>2023年4月6日至2023年4月30日</p>
          </div>
          <div class="item"> 
            <p class="title">活动对象</p>
             <p>浙江省内各高校师生</p>
           </div>
           <div class="item"> 
            <p class="title">组织机构</p>
             <p>主办单位：浙江省高校图书情报工作委员会</p>
             <p>承办单位：湖北中文在线数字出版有限公司</p>
           </div>
           <div class="item"> 
            <p class="title">活动内容</p>
             <p>“书声琅琅”听书问答大挑战</p>
           </div>
           <div class="item">
           <p class="title">参赛形式</p>
            <p>此次阅读活动将在“书香浙江省高校图书馆”（zjgxtgw.chineseall.cn）互联网阅读平台、微信云阅读同步进行，用户登陆活动指定页面参与，投稿请务必注明有效联系方式及机构名称，以便获奖联系，未留联系方式者视为自动放弃评选资格。</p> 
            <p class="title2">（1）比赛规则</p>
            <p>
              一套知识竞赛题共20题，每道题得分为5分，总分100分。答对一题得5分，答错不扣分。答完所有题后系统会自动统计出用户最后得分，每个用户只能提交一次答案，获得一个成绩。最终名次按分数排行，分数相同的参与者根据答题时间长短依次排名，截止日期后不能再答题提交成绩。优秀组织奖根据学校组织宣传及参与人数和成绩最终评定。
            </p> 
           </div>
            <div class="item">
            <p class="title">活动说明</p>
            <p>1．本活动适用对象为参加活动的用户和机构，参加活动的用户指在本次活动（2023 年 4月6日—2023 年 4 月 30 日）期间，成功使用个人账号登录系统的用户；用户成功参加活动后，其所属机构也视为成功参加活动。</p>
            <p>2．活动期间严禁恶意刷数据，对数据异常的参赛者将取消参赛资格。</p>
            <p>3．大赛荣誉证书由浙江省高等学校图书情报工作委员会盖章。</p>
            <p>4．大赛奖项评定由主办单位浙江省高等学校图书情报工作委员会、承办单位湖北中文在线数字出版有限公司评审。</p>
           </div>

           <div class="item"> 
            <p class="title">联系方式</p>
            <p class="title2">活动咨询</p>
            <p>张银翘 18867524182     毛仕转 18758867078</p>
           </div>

           <div class="item group">
             <div class="group-item">
              <p class="title2 text-center">2023高校单位交流群</p>
              <p class="code-img"><img   src="../../assets/img/m/activity/group1.png"></p>
             </div>
             <div class="group-item">
              <p class="title2 text-center">2023浙江省高校读者交流群</p>
              <p class="code-img"><img   src="../../assets/img/m/activity/group2.png"></p>
             </div>
           </div>
        </div>
      </div>
    
    <!-- <div class="code-box">
      <div class="code">
          <img class="code-img" src="../../assets/img/m/activity/code.jpg" alt />
      </div>
      <a href="https://ks.wjx.top/vm/wY2vAo2.aspx" target="_blank"><img class="goto" src="../../assets/img/m/activity/btn.png" alt /></a>
    
    </div> -->
  </div>
</template>

<script>
export default {
  name: "activity",
  data() {
    return {
       
    };
  },
  created() {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.activity {
  width: 100%;
  height:  auto;
  margin: auto;
  position: relative;
  .title-img{
    width: 7.46rem;
    height: auto;
    display: inline-block;
    margin: auto;
  }
   .prize-dec {
      width: 100%;
      height: auto;
      position: relative;
      padding: 0.3rem 0.3rem 0.6rem;
      font-size: 0.3rem;
      color: #3C3C3C; 
      text-align: center;
      .other{
        width: 100%;
        font-size: 0.32rem;
        color: #3C3C3C;
        text-align: center;
        font-family: 'fangsong',Source Han Serif SC;
        font-weight: bold;
        margin-top: 0.3rem;
      }
      .prize-img {
        width: 100%;
        display: flex;
        justify-content: space-between;
        text-align: center;
        font-size: 0.18rem;
        color: #3C3C3C; 
        font-family: 'fangsong',Source Han Serif SC;
        font-weight: bold;
        .item {
          width: 30%;
          .level{
            margin-top: 0.2rem;
            font-size: 0.4rem;
          }
          .name{
            font-size: 0.32rem;
            margin-top: 0.1rem;
          }

          > img {
            width: 100%;
            height: auto; 
            display: block;
            margin: auto;
          }
        }
      }
      .remark{
         margin-top: 0.2rem;
         font-size: 0.2rem;
         color: #3C3C3C;
      }
      .activity-box{
        text-align: center;
        font-size: 0.48rem;
        color: #323232;
        font-family: fangsong;
        line-height: 1.6em;
        font-weight: bold;
        margin-top: 0.6rem;
        .item{
          font-size: 0.32rem;
          width: 100%;
          margin-top: 0.3rem;
          line-height: 1.4em;
        }
        .item.group{
          display: flex;
          justify-content: space-between;
          align-items: start;
          margin-top: 0.5rem;
          .group-item{
            width: 40%;
            .title2{
              margin-bottom: 0.2rem;
            }
            img{
              width: 3.7rem;
            }
          }
        }
         .title{
            font-weight: bold;
            font-size: 0.48rem;
            line-height: 1.2em;
          }
        .time{
          margin-bottom:0.3rem ;
        }
        .rule{
          margin-top: 0.5rem;
         
        }
      }
    }
  .text-box{
    width: 100%;
    height: auto; 
    position: relative;
    display: block;
    margin: auto; 
    color: #3C3C3C;
    font-size: 0.4rem; 
    >p{
      font-size: 0.4rem;
      font-family: fangsong,ui-sans-serif, PingFangSC-Regular !important;
      font-weight: bold;
      color: #3C3C3C;
      line-height: 1.4em;
      text-indent: 2em;
      text-align: left;
    }
    >p+p{
      margin-top: 0.2rem;
    }
    .part{
        width: 100%;
        height: auto;
        font-size: 0.48rem; 
        color: #212020;
        line-height: 1.5em;
        text-align: center;
      }
      .part+.part{
        margin-top: 0.2rem;
      }
  }

 .title-img{
  width: 8.73rem;
  height: auto;
  position: relative;
  display: block;
  margin: 0.56rem auto 0.17rem;
 }
  .code-box {
    width: 100%;
    height: auto;
    position: relative;
    margin-top: 0.57rem;
    
    .code{
      width: auto;
      display: inline-block;
      //padding: 0.2rem;
      //background-color: #fff;
      background-color: #E6F3FF;
    padding: 0.5rem;
    >div{
      background-color: #fff;
    padding-bottom: 0.2rem;
    color: #999;
    }
    }
    
    .code-img{
      width: 5.53rem;
      height: auto;
      display: block;
      margin: auto;
      font-size: 0;
    }
    .goto{
      width: 6.14rem;
      height: 1.03rem;
      display: block;
      margin: 0.24rem auto 0.1rem;
    }
    .time{
      font-size: 0.28rem;
      font-family: fangsong;
      font-weight: bold;
      color: #FDD55A;
      line-height: 0.36rem;
    }
   
  }
  
}
</style>
